<modal #connectionInterruptionDialog class="connection-lost-popup dialog-top-priority">
    <!-- <ng-template #modalHeader>
      {{params.header}} 
    </ng-template> -->
    <ng-template #modalBody>
        <div class="interruption-header" [i18n]="'app.nwInterrrupted'"></div>
        <div class="interruption-content">{{ params.message }}</div>
        <div [i18n]="'app.ok'" class="interruption-close-button" (click)="closeInterruptionPopup()"></div>
    </ng-template>
</modal>
